var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{SGD:this.$institut === 'SGD', HFB: this.$institut === 'HFB', TEC: this.$institut === 'TEC', IOC: this.$institut === 'IOC', APP: this.$institut === 'APP', },attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }